import styled from 'styled-components';
import { StyledAdditionalBaseOptionProps } from './AdditionalBaseOption.types';

export const StyledAdditionalBaseOption = styled.button<StyledAdditionalBaseOptionProps>`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  ${(props) => props.customStyle}
`;
